import { render, staticRenderFns } from "./ProductContainerCombobox.vue?vue&type=template&id=23ab5e5a&scoped=true&"
import script from "./ProductContainerCombobox.vue?vue&type=script&lang=ts&"
export * from "./ProductContainerCombobox.vue?vue&type=script&lang=ts&"
import style0 from "./ProductContainerCombobox.vue?vue&type=style&index=0&id=23ab5e5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ab5e5a",
  null
  
)

export default component.exports